import React, { lazy } from "react";

import { VIEW_LICENSE_TEMPLATE_PERMISSION } from "constants/permissions";

const LicenseTemplatePage = lazy(() => import("./LicenseTemplatePage"));

const licenseTemplateRoute = {
  path: "licenses.template",
  element: <LicenseTemplatePage />,
  root: false,
  permission: VIEW_LICENSE_TEMPLATE_PERMISSION,
};

export default licenseTemplateRoute;
